import React, { useState } from "react";
import { addAddress } from "../../api/apiServices";

const AddressForm = ({
  setShowAddressForm,
  editAddress,
  setEditAddress,
  onSuccess,
  hideCancel = false,
}) => {
  const [newAddress, setNewAddress] = useState(
    editAddress
      ? editAddress
      : {
          full_name: "",
          mobile_no: JSON.parse(localStorage.getItem("userData"))?.phone_no,
          street1: "",
          street2: "",
          city: "",
          pincode: "",
          type: "Domestic",
        }
  );

  const submitHandler = async (e) => {
    e.preventDefault();

    try {
      await addAddress({ ...newAddress });
      setNewAddress({
        full_name: "",
        mobile_no: "",
        street1: "",
        street2: "",
        city: "",
        pincode: "",
        type: "Domestic",
      });

      onSuccess();
    } catch (error) {
      console.error("Error adding address:", error);
    }
  };

  const inputClass =
    "border border-gray-300 rounded-lg px-3 py-2.5 sm:py-2 text-base shadow-sm focus:ring-2 focus:ring-amber-500/30 focus:border-amber-500 outline-none min-h-[44px] sm:min-h-[40px]";
  const labelClass = "flex flex-col gap-1 text-sm font-medium text-gray-700";

  return (
    <form
      action=""
      className="flex flex-col gap-4 sm:gap-5 p-4 sm:p-6 bg-gray-50/50"
      onSubmit={submitHandler}
    >
      <fieldset className="flex flex-col gap-2">
        <legend className="text-sm font-medium text-gray-700 mb-1">Address type</legend>
        <div className="flex flex-wrap gap-4 sm:gap-6">
          <label className="flex items-center gap-2 cursor-pointer min-h-[44px] sm:min-h-0">
            <input
              type="radio"
              value="Domestic"
              checked={newAddress.type === "Domestic"}
              onChange={(e) =>
                setNewAddress({ ...newAddress, type: e.target.value })
              }
              className="w-4 h-4"
            />
            <span>Domestic</span>
          </label>
          <label className="flex items-center gap-2 cursor-pointer min-h-[44px] sm:min-h-0">
            <input
              type="radio"
              value="International"
              checked={newAddress.type === "International"}
              onChange={(e) =>
                setNewAddress({ ...newAddress, type: e.target.value })
              }
              className="w-4 h-4"
            />
            <span>International</span>
          </label>
        </div>
      </fieldset>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-5">
        <label className={labelClass}>
          Full Name
          <input
            required
            type="text"
            className={inputClass}
            onChange={(e) =>
              setNewAddress({ ...newAddress, full_name: e.target.value })
            }
            value={newAddress.full_name}
            placeholder="Your full name"
          />
        </label>
        <label className={labelClass}>
          Mobile No.
          <input
            disabled
            required
            value={
              JSON.parse(localStorage.getItem("userData"))?.phone_no ?? ""
            }
            type="tel"
            className={`${inputClass} bg-gray-100 cursor-not-allowed`}
            onChange={(e) =>
              setNewAddress({ ...newAddress, mobile_no: e.target.value })
            }
          />
        </label>
      </div>

      <label className={labelClass}>
        Flat, House no., Building
        <input
          required
          type="text"
          className={inputClass}
          onChange={(e) =>
            setNewAddress({ ...newAddress, street1: e.target.value })
          }
          value={newAddress.street1}
          placeholder="Building / flat number"
        />
      </label>
      <label className={labelClass}>
        Area, Colony, Street
        <input
          required
          type="text"
          className={inputClass}
          onChange={(e) =>
            setNewAddress({ ...newAddress, street2: e.target.value })
          }
          value={newAddress.street2}
          placeholder="Area, colony or street"
        />
      </label>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-5">
        <label className={labelClass}>
          Town / City
          <input
            required
            type="text"
            className={inputClass}
            onChange={(e) =>
              setNewAddress({ ...newAddress, city: e.target.value })
            }
            value={newAddress.city}
            placeholder="City"
          />
        </label>
        <label className={labelClass}>
          Pin Code
          <input
            required
            type="text"
            inputMode="numeric"
            pattern="[0-9]*"
            className={inputClass}
            onChange={(e) =>
              setNewAddress({ ...newAddress, pincode: e.target.value })
            }
            value={newAddress.pincode}
            placeholder="Pincode"
          />
        </label>
      </div>

      <div className="flex flex-col-reverse sm:flex-row gap-3 mt-2 pt-4 border-t border-gray-200">
        {!hideCancel && (
          <button
            type="button"
            className="btn-rounded-secondary rounded-full flex items-center justify-center gap-2 text-sm min-h-[44px] sm:min-h-0 w-full sm:w-auto px-6"
            onClick={() => {
              setShowAddressForm(false);
              setNewAddress({
                full_name: "",
                mobile_no: "",
                street1: "",
                street2: "",
                city: "",
                pincode: "",
              });
              if (editAddress) {
                setEditAddress(null);
              }
            }}
          >
            Cancel
          </button>
        )}
        <button
          type="submit"
          className="btn-rounded-primary rounded-full flex items-center justify-center gap-2 text-sm min-h-[44px] sm:min-h-0 w-full sm:w-auto px-6"
        >
          Save Address
        </button>
      </div>
    </form>
  );
};

export default AddressForm;
